import { RouteObject } from 'react-router-dom';
import { Landing } from './components/Landing';
import { Landing as DetailLanding } from './components/detail/Landing';

export interface allAccountsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: allAccountsRoute[];
}

export const allAccountsRoutes: allAccountsRoute[] = [
  {
    path: '/dashboard/all-accounts',
    element: <Landing />,
    auth: false,
  },
  {
    path: '/dashboard/all-accounts/:id',
    element: <DetailLanding />,
    auth: false,
  }
];
